import { render, staticRenderFns } from "./blackListPersonDetail.vue?vue&type=template&id=749f74b1&scoped=true&"
import script from "./blackListPersonDetail.vue?vue&type=script&lang=js&"
export * from "./blackListPersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./blackListPersonDetail.vue?vue&type=style&index=0&id=749f74b1&prod&lang=less&scoped=true&"
import style1 from "./blackListPersonDetail.vue?vue&type=style&index=1&id=749f74b1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749f74b1",
  null
  
)

export default component.exports